import { render, staticRenderFns } from "./ProformCategoryTableAdmin.vue?vue&type=template&id=d77a06bc&scoped=true"
import script from "./ProformCategoryTableAdmin.vue?vue&type=script&lang=js"
export * from "./ProformCategoryTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77a06bc",
  null
  
)

export default component.exports